module.exports = __webpack_public_path__ + "3f0855cdba0dae6436d1d9ae1f133813.svg";